import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { CONTACT } from "../../content";
import { useT } from "../../i18n/LangContext";

const link = "transition-colors hover:text-black";

const Col = ({ label, children }) => (
  <div>
    <p className="text-sm font-bold text-black">{label}</p>
    <div className="mt-3 space-y-2 text-sm text-zinc-600">{children}</div>
  </div>
);

export const Footer = () => {
  const all = useT();
  const t = all.footer;
  const legal = [
    ["/privacy", all.legal.footer.privacy, "footer-privacy-link"],
    ["/terms", all.legal.footer.terms, "footer-terms-link"],
    ["/delete-account", all.legal.footer.deleteAccount, "footer-delete-account-link"],
  ];
  return (
    <footer className="border-t border-black/10 bg-white px-5 pb-28 pt-14 sm:px-8 sm:pb-10" data-testid="site-footer">
      <div className="mx-auto max-w-7xl">
        <Logo />
        <p className="mt-4 max-w-sm text-sm text-zinc-600">{t.about}</p>
        <div className="mt-10 grid gap-8 sm:grid-cols-3">
          <Col label={t.company}>
            <p className="text-black">Costataxicy</p>
            <address className="not-italic" data-testid="footer-address">
              {t.address1}
              <br />
              {t.address2}
            </address>
          </Col>
          <Col label={t.phone}>
            <a href={CONTACT.tel} className={`block ${link}`} data-testid="footer-phone">{CONTACT.phoneDisplay}</a>
            <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className={`block ${link}`} data-testid="footer-whatsapp">{t.chat}</a>
          </Col>
          <Col label={t.email}>
            <a href={`mailto:${CONTACT.email}`} className={`block break-all ${link}`} data-testid="footer-email">{CONTACT.email}</a>
            <a href={CONTACT.website} target="_blank" rel="noopener noreferrer" className={`block ${link}`} data-testid="footer-website">costataxicy.com</a>
          </Col>
        </div>
        <nav className="mt-12 flex flex-wrap gap-x-6 gap-y-3 text-sm" aria-label="Legal" data-testid="footer-legal-links">
          {legal.map(([slug, label, testid]) => (
            <Link key={slug} to={all.pathFor(slug)} className="text-zinc-700 underline-offset-4 hover:text-black hover:underline" data-testid={testid}>
              {label}
            </Link>
          ))}
        </nav>
        <div className="mt-6 flex flex-col justify-between gap-2 border-t border-black/10 pt-6 text-xs text-zinc-600 sm:flex-row">
          <p>© {new Date().getFullYear()} Costataxicy. {t.rights}</p>
          <p>gettaxcy.com</p>
        </div>
      </div>
    </footer>
  );
};
